export default __webpack_public_path__ + "static/media/headerPopupWin.4a068147.png";